import { TServerErrorResponse, PhoneNumber, ContactPhoneType } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";
import { removeNonNumeric } from "@/lib";

export const addClientPhone = async (
  clientId: string,
  {
    number,
    type,
    extension,
    primary,
  }: {
    number: string;
    type: ContactPhoneType;
    extension?: string;
    primary?: boolean;
  },
): Promise<PhoneNumber> => {
  try {
    const response = await http.post<PhoneNumber>(
      links.client.phones(clientId),
      { number: removeNonNumeric(number), type, extension, primary },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateClientPhone = async (
  clientId: string,
  phoneId: string,
  {
    number,
    type,
    extension,
  }: { number?: string; type?: ContactPhoneType; extension?: string },
): Promise<PhoneNumber> => {
  try {
    const response = await http.patch<PhoneNumber>(
      links.client.phoneById(clientId, phoneId),
      {
        number: number !== undefined ? removeNonNumeric(number) : undefined,
        type,
        extension,
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteClientPhone = async (
  clientId: string,
  phoneId: string,
): Promise<void> => {
  try {
    await http.delete(links.client.phoneById(clientId, phoneId));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const setPrimaryClientPhone = async (
  clientId: string,
  phoneId: string,
): Promise<PhoneNumber> => {
  try {
    const response = await http.patch<PhoneNumber>(
      links.client.phoneSetPrimary(clientId, phoneId),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
